'use client';

import { PathEnum } from '@/types/enums';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Button from '../ui/Button';
import H2 from '../ui/H2';
import H4 from '../ui/H4';
import Link from '../ui/Link';
import AnimatedNumberSection from '../ui/Numbers';

export default function InfoCardsSectionView({
    manufacturedParts,
}: {
    manufacturedParts: number;
}) {
    const t = useTranslations();

    return (
        <section className="w-full bg-white py-[180px] max-lg:py-[60px] max-lg:px-4">
            <div className="flex justify-between container mx-auto px-0 xl:gap-[60px] gap-10 max-lg:flex-col p-[30px] max-lg:gap-[60px] place-items-stretch">
                <div className="flex flex-col w-1/3 max-lg:w-full lg:min-h-[370px] my-auto relative">
                    <Image
                        className="object-contain absolute -bottom-12 -right-24 z-0 max-lg:scale-75"
                        width={450}
                        height={190}
                        src="/img/train.webp"
                        alt="Train"
                    />
                    <div className="h-full my-auto flex flex-col gap-7 relative z-1">
                        <H2 className="leading-tight">
                            {t('Metadata.Homepage.headings.leadingManufacturing')}
                        </H2>
                        <p className="leading-tight text-h5 font-normal lg:text-h4 lg:font-medium">
                            {t('HomePage.expertKnowHow')}
                        </p>
                        <Link className="get-offer-trigger w-fit" href={PathEnum.Contact}>
                            <Button title={t('Buttons.getOffer')} withArrow variant="secondary" />
                        </Link>
                    </div>
                </div>
                <div className="flex flex-col w-1/3 max-lg:w-full relative p-[30px] max-lg:p-5 min-h-[370px] max-lg:min-h-[266px]">
                    <div className="w-full h-full absolute top-0 left-0">
                        <Image
                            className="object-cover"
                            fill
                            src="/img/Main_Home_Rev_Image_3.webp"
                            alt="service"
                        />
                    </div>
                    <div className="relative z-10 flex flex-col">
                        <AnimatedNumberSection
                            className="text-[100px] font-medium"
                            number={manufacturedParts}
                        />
                        <H4 className="leading-tight text-white">
                            {t('HomePage.weAreExperienced')}
                        </H4>
                        <Link
                            href={PathEnum.Services}
                            className="mt-3 w-fit"
                            ariaLabel={t('AllServices.readMore')}
                        >
                            <>
                                <span className="sr-only">{t('AllServices.readMore')}</span>
                                <Button title={t('AllServices.readMore')} withArrow />
                            </>
                        </Link>
                    </div>
                </div>
                <div className="flex flex-col w-1/3 max-lg:w-full bg-light-grey p-[30px] max-lg:p-5 relative min-h-[370px] max-lg:min-h-[266px]">
                    <H4>{t('HomePage.trustedGlobally')}</H4>
                    <Link
                        className="mt-7 max-lg:mt-4 w-fit relative z-10"
                        href={PathEnum.About}
                        ariaLabel={t('AllServices.readMore')}
                    >
                        <>
                            <span className="sr-only">{t('AllServices.readMore')}</span>
                            <Button
                                className="bg-light-grey"
                                title={t('AllServices.readMore')}
                                withArrow
                                variant="secondary"
                            />
                        </>
                    </Link>
                    <Image
                        className="rounded-tl-10 absolute bottom-0 right-0 max-lg:hidden"
                        width={340}
                        height={166}
                        src="/img/Main_Home_Image_2.webp"
                        alt="service"
                    />
                    <Image
                        className="rounded-tl-10 absolute bottom-0 right-0 max-lg:block hidden"
                        width={244}
                        height={120}
                        src="/img/Main_Home_Image_2.webp"
                        alt="service"
                    />
                </div>
            </div>
        </section>
    );
}
